'use client';

import { usePageLayout } from '@libs/common-next';
import type { MappedProductVariant } from '@libs/algolia';
import {
    Analytics,
    TrackingEvents,
    getNavigationId,
    getNavigationName,
    processFindingMethod,
    trackEEAddToWishlist,
    useAnalyticsContext,
} from '@libs/analytics';
import { getEcommerceInfo } from '@app/pdp/utils';
import { useProductDetails } from '@app/pdp/hooks';
import VelocityFavoriteProductIcon from './VelocityFavoriteProductIcon';

export default function FavoriteProductIcon() {
    const { ocapi } = usePageLayout();
    const { product: masterProduct } = useProductDetails();
    const { getSearchStats } = useAnalyticsContext();

    const callAnalytics = (productToFavorite: MappedProductVariant) => {
        const findingMethod = processFindingMethod(
            window.sessionStorage.pdpFindingMethod
        );

        const isDefaultProduct =
            String(productToFavorite.id) === String(masterProduct.id);

        const { searchTerm } = getSearchStats();
        trackEEAddToWishlist(productToFavorite, masterProduct);
        Analytics.on(TrackingEvents.ADD_TO_WISHLIST, {
            ecommerce: getEcommerceInfo({
                product: productToFavorite,
                ocapi: ocapi.data ?? null,
                listInfo: {
                    id: getNavigationId(findingMethod),
                    name: getNavigationName(findingMethod),
                },
                categoryInfo: {
                    primaryCategoryId: Number(
                        masterProduct?.primary_category_id ?? '0'
                    ),
                    categories: masterProduct?.categories ?? null,
                },
                isDefaultProduct,
                lastSearchQuery: searchTerm,
            }),
        });
    };

    return <VelocityFavoriteProductIcon callAnalytics={callAnalytics} />;
}
